import { render, staticRenderFns } from "./ListAsetDiputihkanPage.vue?vue&type=template&id=9094cce2"
import script from "./ListAsetDiputihkanPage.vue?vue&type=script&lang=js"
export * from "./ListAsetDiputihkanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports